






















import { BasicStrengthDTO } from '../../../src_server/entity/dto/BasicStrengthDTO';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BasicStrengthDaily } from '../../../src_server/entity/generated/BasicStrengthDaily';
import BasicStrenghtRow from './BasicStrenghtRow.vue';
import { BasicStrengthLevelService } from '../../biz/remote/BasicStrengthLevelService';
import { BasicStrengthLevel } from '../../../src_server/entity/generated/BasicStrengthLevel';
import { MessageDialog } from '../../utils/MessageDialog';

class BasicStrengthDailyExt extends BasicStrengthDaily {
  public get current_level_title() {
    return this.current_level;
  }
}
@Component({ components: { BasicStrenghtRow } })
export default class SupportPlanBasicStrengthSection extends Vue {
  @Prop({ default: '' })
  user_id!: string;

  private basicStrenghtLevels: BasicStrengthLevel[] = [];

  async created() {
    // 基礎力レベルを取得
    const bslbiz = new BasicStrengthLevelService();
    const bslResponse = await bslbiz.getBasicStrengthLevel(this.user_id);
    this.basicStrenghtLevels = bslResponse.data;
  }

  inputRow(st: BasicStrengthDTO, index: number) {
    this.basicStrenghtLevels.splice(index, 1, st);
  }

  async update() {
    // 基礎力レベルを更新する
    const bslBiz = new BasicStrengthLevelService();
    await bslBiz.update(this.basicStrenghtLevels);
    await MessageDialog.alert('更新が完了しました');
  }
}
